/**
 * CAAA1012：ログイン前情報取得API（入力項目）
 */
export default class CAAA1012RequestModel {}
